import moment from "moment";
export default class DateHelper {
  getFormattedDateTime(date) {
    return moment(date).fromNow();
  }
}
